export default __webpack_public_path__ + "static/media/united-arab-emirates.0cccc8dc.svg";